import { mutations } from "./mutations";
import { getters } from "./getters";
import { actions } from "./actions";
import { MainState } from "./state";

const defaultState: MainState = {
  mobile: "",
  isLoggedIn: null,
  isTokenSent: null,
  token: "",
  logInError: false,
  userProfile: null,
  dashboardMiniDrawer: false,
  dashboardShowDrawer: true,
  notifications: [],
  miners: [],
  shares: [],
  calling: false,
  withdraws: [],
  withdrawStates: [],
  image: null,
  incomes: [],
  companies: [],
  isLicenceAccepted: true

};

export const mainModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
